<template>
    <div>

        <!-- Start Services Details Area -->
		<section class="services-details-area ptb-80 mt-5">
			<div class="container">
				<div class="section-title">
                <h2>Web Design & Development</h2>
                <div class="bar"></div>
            </div>
				<div class="row align-items-center">
					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<!-- <h3>Incredible Infrastructure</h3> -->
							<p>As a full fledged software development company our one stop web development platform is one of the best in the market with all the latest technologies such as PHP framework Magento HTML Java with SEO that you will need to build a successful business platform. </p>

							<p>Our team will help you to embrace mobile centric web reality and transform legacy systems into modern cross platform applications. We will implement end-to-end enterprise solutions and our team builds one of the most demanded web applications in the market.</p>
						</div>
					</div>

					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/1.png" class="wow fadeInUp" v-wow alt="image">
					</div>
				</div>

				<div class="separate"></div>

				<div class="row align-items-center">
					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/2.png" class="wow fadeInUp" v-wow alt="image">
					</div>

					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<p>We deliver functional and convenient with visually appealing intuitive designs using HTML and JavaScript so that it looks fantastic on both mobiles and PCsOur cross platform solutions make sure that the application runs flawlessly on all the platforms with no issues.</p>

							<div class="services-details-accordion">
								<VueFaqAccordion 
									:items="myItems"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        <!-- End Services Details Area -->
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion';
export default {
	name: 'ServiceDetails',
	components: {
        VueFaqAccordion
    },
    data() {
        return {
            text: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute.`,
       myItems: [
                {
                    title: 'Innovative Technology',
                    value: 'We leverage cutting-edge technology and methodologies to develop powerful sales automation software.'
                },
                {
                    title: 'Customer Partners',
                    value: 'We apply deep domain and hosting knowledge to support our clients’ technology and business goals.'
                },
                {
                    title: 'First-Rate Services',
                    value: 'We are committed to delivering best-in-class technology and customer service, building long lasting business partnerships.'
                }
            ]
        }
    }
}
</script>